import { useCallback } from "react";

import { useTrackerAuth } from "components/AuthProvider";

import { useAuthGateDisclosure } from "./useQueryParamDisclosure";

const LOCAL_STORAGE_KEY = "searches72";
const MAX_SEARCHES_PER_WINDOW = 1;

interface Searches {
  count: number;
  timestamp: number;
}

export function useSearchAuthGate() {
  const [regModalOpened, { toggle: toggleRegModal, open: openRegModal }] = useAuthGateDisclosure();
  const { user } = useTrackerAuth();

  const isUserLoggedIn = user !== null && user !== undefined;

  const handleSearchAttempt = useCallback(() => {
    const now = new Date();
    const seventyTwoHoursInMs = 72 * 60 * 60 * 1000;
    const searches = getSearchesFromLocalStorage();

    if (isUserLoggedIn) {
      return true;
    }

    if (now.getTime() - searches.timestamp >= seventyTwoHoursInMs) {
      searches.timestamp = now.getTime();
      searches.count = 0;
    }

    if (searches.count >= MAX_SEARCHES_PER_WINDOW) {
      openRegModal();
      return false;
    }

    searches.count += 1;
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(searches));

    return true;
  }, [isUserLoggedIn, openRegModal]);

  return {
    handleSearchAttempt,
    regModalOpened,
    toggleRegModal,
    openRegModal,
  };
}

function getSearchesFromLocalStorage(): Searches {
  const searchesData = localStorage.getItem(LOCAL_STORAGE_KEY);
  if (searchesData) {
    return JSON.parse(searchesData);
  }

  return { count: 0, timestamp: new Date().getTime() };
}
